import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';

import { BodyText, Button, Card, Divider, Eyebrow, Stack } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { PhoneNumbersExportStore } from '../stores/phone-numbers-export.store';
import * as Styles from './phone-numbers-export.module.less';
import classNames from 'classnames';

export const PhoneNumbersExport: FC = observer(() => {
    const [store] = useDependencies(PhoneNumbersExportStore);

    return store.timestamp ? (
        <Card className={classNames(Styles.phoneNumbersExport, 'm-t-2 m-b-4')} thin>
            <div className="ta-center">
                <Eyebrow bold className="c-neutral-300">
                    Last successfull export
                </Eyebrow>
            </div>
            <Divider className="m-t-1 m-b-2" />
            <Stack spacing={3}>
                <Button primary outline iconName="file_download" onClick={store.download}>
                    Download
                </Button>
                <Stack spacing={1}>
                    <div>
                        <BodyText size="small" bold>
                            Created on:
                        </BodyText>
                        <BodyText size="small" bold>
                            By user:
                        </BodyText>
                    </div>
                    <div>
                        <BodyText size="small">{store.timestamp.toLocaleString()}</BodyText>
                        <BodyText size="small">{store.user}</BodyText>
                    </div>
                </Stack>
            </Stack>
        </Card>
    ) : (
        <Fragment />
    );
});
